import { createApiClient } from 'Network/ApiClient';

export const DoctorAxiosInstance = createApiClient('Doctor/');


